import React from "react";
import { useForm, ValidationError } from "@formspree/react";
import "../../Components/settings/settings.css";

const ContactUs = () => {
  const [state, handleSubmit] = useForm("mjgjwggw");

  return (
    <div className="page">
      <div className="settings-container">
        <h2 className="settings-page-title">Contact Us</h2>

        <section className="about-section">
          <p>
            Have a question, feedback, or need help with your account? Fill out
            the form below and we'll get back to you within 1–2 business days.
          </p>
        </section>

        {state.succeeded ? (
          <section className="about-section">
            <p>Thanks for reaching out — we'll be in touch soon.</p>
          </section>
        ) : (
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="contact-form-group">
              <label htmlFor="name">Name</label>
              <input id="name" type="text" name="name" required />
              <ValidationError field="name" prefix="Name" errors={state.errors} />
            </div>

            <div className="contact-form-group">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" name="email" required />
              <ValidationError field="email" prefix="Email" errors={state.errors} />
            </div>

            <div className="contact-form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" rows="6" required />
              <ValidationError field="message" prefix="Message" errors={state.errors} />
            </div>

            <ValidationError errors={state.errors} />

            <button type="submit" disabled={state.submitting}>
              {state.submitting ? "Sending…" : "Send Message"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ContactUs;
